var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { BaseService } from '../BaseService';
import { memLock } from '../Retainable';
import { extractErrorMessage } from '../extractErrorMessage';
import { AuthenticationService } from '../AuthenticationService';
import { RtService } from '../RtService';
import { camelToSnakeCase } from '../utils/request';
import EntitiesBus from './EntitiesBus';
function primitiveCompare(a, b) {
    if (a === b)
        return 0;
    if (a === null || a === undefined)
        return -1;
    if (b === null || b === undefined)
        return 1;
    if (a === true)
        a = 1;
    if (b === false)
        b = 0;
    if (typeof a === 'number' && typeof b === 'number')
        return a - b;
    if (typeof a === 'string' && typeof b === 'string')
        return a.localeCompare(b);
    return String(a).localeCompare(String(b));
}
function getIdxWithOrderBy(arr, e, comparator) {
    let lo = -1, hi = arr.length;
    while (hi - lo > 1) {
        let m = (lo + hi) >> 1;
        let c = comparator(e, arr[m]);
        if (c > 0) {
            lo = m;
        }
        else if (c < 0) {
            hi = m;
        }
        else {
            return m;
        }
    }
    return hi;
}
function checkEntityOnFilters(e, filters) {
    if (filters && typeof filters === 'object') {
        const keys = Object.keys(filters);
        const keysSnake = keys.map(f => camelToSnakeCase(f));
        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            const ks = keysSnake[i];
            if (!(e.hasOwnProperty(ks) && e[ks] === filters[key]))
                return false;
        }
    }
    return true;
}
function updateOneEntity(entities, e, orderBy) {
    const idx = entities.findIndex(entity => String(entity.id) === String(e.id));
    entities = entities.slice(0); //           
    if (idx !== -1) {
        //                
        if (orderBy) {
            //                                                   
            entities.splice(idx, 1);
            const comparator = (e1, e2) => {
                for (let key of orderBy) {
                    let cmp = primitiveCompare(e1[key], e2[key]);
                    if (cmp)
                        return cmp;
                }
                return 0;
            };
            let newIdx = getIdxWithOrderBy(entities, e, comparator);
            entities.splice(newIdx, 0, e);
        }
        else {
            //                                 
            entities[idx] = e;
        }
    }
    else {
        //           
        //                   
        entities.push(e);
    }
    return entities;
}
function makeModel(error, loading, tableName, entities = []) {
    const model = entities;
    model.error = error;
    model.loading = loading;
    model.entities = entities;
    model[tableName] = entities;
    return model;
}
export class BaseEntitiesService extends BaseService {
    _repo;
    _schemaName;
    _schema_name;
    _tableName;
    /* 
                                                                                                         
                 
     */
    _rtSync;
    constructor(repo) {
        super(makeModel('', true, repo.getTableName(), []));
        this._repo = repo;
        this._schema_name = this._schemaName = this._repo.getSchemaName();
        this._tableName = this._repo.getTableName();
        this._rtSync = true;
        this._subscriptions.push(RtService.getInstance().subscribeDataset(this._schemaName, this._onRtMessage));
        EntitiesBus.subscribe([`${this._schemaName}.${this._tableName}`], this._onBusCommands);
        //                                                                               
        //                                                                        
        //                                                                           
        EntitiesBus.subscribe([`R ${this._schemaName}.*`, `R ${this._schemaName}.${this._tableName}`], this._onAtlasResynced);
        if (this._shouldCheckAuth()) {
            //                                                                 
            //                                                                      
            //                                                                     
            //                                                   
            this._subscriptions.push(AuthenticationService.getInstance().subscribeAndNotify(['authenticated', 'loading', 'error'], () => this._init()));
        }
        else {
            this._init();
        }
    }
    _dispose() {
        EntitiesBus.unsubscribe(this._onBusCommands);
        EntitiesBus.unsubscribe(this._onAtlasResynced);
        super._dispose();
    }
    getSchemaName() {
        return this._schemaName;
    }
    getTableName() {
        return this._tableName;
    }
    getMeta() {
        return this._repo.meta();
    }
    reload() {
        return this._init();
    }
    async getNextId() {
        return this._repo.getNextId();
    }
    //                                                                         
    //                                                                   
    //                                                                       
    _onAtlasResynced = () => {
        this._init();
    };
    _onBusCommands = (commands) => {
        let cCommands = commands.filter(c => c.action === 'C'), uCommands = commands.filter(c => c.action === 'U'), dCommands = commands.filter(c => c.action === 'D');
        const udBodies = [].concat(cCommands.map(c => c.payload), uCommands.map(c => c.payload));
        const deleteIds = dCommands.map(c => c.object_id);
        this.updateInternalManyEntities(udBodies, deleteIds);
    };
    _shouldCheckAuth() {
        return this._schemaName !== 'ds_res';
    }
    async save(entity) {
        if (this._model.error)
            throw new Error('Invoke create on error service');
        if (this._model.loading)
            throw new Error('Invoke create on loading service');
        if (entity.id) {
            const id = entity.id;
            delete entity.id;
            return this.updateOne(id, entity);
        }
        else {
            delete entity.id;
            return this.create(entity);
        }
    }
    async create(partialEntity) {
        if (this._model.error)
            throw new Error('Invoke create on error service');
        if (this._model.loading)
            throw new Error('Invoke create on loading service');
        const e = await this._create(partialEntity);
        return e;
    }
    updateOne(id, partialEntity) {
        if (this._model.error)
            throw new Error('Invoke updateOne on error service');
        if (this._model.loading)
            throw new Error('Invoke updateOne on loading service');
        return this._updateOne(id, partialEntity);
    }
    updateMany(partialEntities) {
        if (this._model.error)
            throw new Error('Invoke updateOne on error service');
        if (this._model.loading)
            throw new Error('Invoke updateOne on loading service');
        return this._updateMany(partialEntities);
    }
    createMany(partialEntities) {
        if (this._model.error)
            throw new Error('Invoke create on error service');
        if (this._model.loading)
            throw new Error('Invoke create on loading service');
        return this._createMany(partialEntities);
    }
    remove(id) {
        if (this._model.error)
            throw new Error('Invoke remove on error service');
        if (this._model.loading)
            throw new Error('Invoke remove on loading service');
        return this._remove(id);
    }
    async _repoListInternal() {
        const entities = await this._repo.list();
        return entities;
    }
    //
    //
    //
    async _init() {
        if (this._shouldCheckAuth()) {
            const authModel = AuthenticationService.getModel();
            if (authModel.error)
                return this._setModel(makeModel(authModel.error, false, this._tableName, []));
            if (authModel.loading)
                return this._setModel(makeModel(null, true, this._tableName, []));
            if (!authModel.authenticated)
                return this._setModel(makeModel(AuthenticationService.NOT_AUTHENTICATED, false, this._tableName, []));
        }
        try {
            const entities = await this._repoListInternal();
            this._setModel(makeModel('', false, this._tableName, entities));
        }
        catch (err) {
            this._setModel(makeModel(extractErrorMessage(err), false, this._tableName, []));
        }
    }
    _updateModel(partialModel) {
        this._setModel(makeModel(partialModel.error || this._model.error, partialModel.loading || this._model.loading, this._tableName, Array.isArray(partialModel) ? partialModel : this._model));
    }
    async _create(partialEntity) {
        //                         
        const e = await this._repo.create(partialEntity);
        //                                  
        EntitiesBus.getInstance().publishMany([
            {
                type: `C ${this._schemaName}.${this._tableName}`,
                action: 'C',
                schema_name: this._schemaName,
                table_name: this._tableName,
                object_id: e.id,
                payload: e,
            },
        ]);
        if (this._rtSync) {
            RtService.publishDsMessage(this._schemaName, 'CREATE_' + this._tableName.toUpperCase(), e); //                       
        }
        return e;
    }
    async _updateOne(id, partialEntity) {
        const e = await this._repo.update(id, {
            ...partialEntity, //                                                    
            id: undefined,
        });
        //                                  
        EntitiesBus.getInstance().publishMany([
            {
                type: `U ${this._schemaName}.${this._tableName}`,
                action: 'U',
                schema_name: this._schemaName,
                table_name: this._tableName,
                object_id: e.id,
                payload: e,
            },
        ]);
        if (this._rtSync) {
            RtService.publishDsMessage(this._schemaName, 'UPDATE_' + this._tableName.toUpperCase(), e); //                       
        }
        return e;
    }
    async _updateMany(partialEntities) {
        const es = [];
        const commands = [];
        if (partialEntities.length) {
            const response = await this._repo.updateMany(partialEntities);
            es.push(...response);
            commands.push(...response.map(e => ({
                type: `U ${this._schemaName}.${this._tableName}/${e.id}`,
                action: 'U',
                schema_name: this._schemaName,
                table_name: this._tableName,
                object_id: e.id,
                payload: e,
            })));
        }
        EntitiesBus.getInstance().publishMany(commands);
        if (this._rtSync) {
            RtService.publishDsMessage(this._schemaName, 'UPDATE_' + this._tableName.toUpperCase() + 'S', es); //                       
        }
        return es;
    }
    async _createMany(partialEntities) {
        const es = [];
        const commands = [];
        if (partialEntities.length) {
            const response = await this._repo.createMany(partialEntities);
            es.push(...response);
            commands.push(...response.map(e => ({
                type: `C ${this._schemaName}.${this._tableName}`,
                action: 'C',
                schema_name: this._schemaName,
                table_name: this._tableName,
                object_id: e.id,
                payload: e,
            })));
        }
        EntitiesBus.getInstance().publishMany(commands);
        if (this._rtSync) {
            RtService.publishDsMessage(this._schemaName, 'CREATE_' + this._tableName.toUpperCase() + 'S', es); //                       
        }
        return es;
    }
    async _remove(id) {
        //                                                                      
        await this._repo.remove(id);
        //                                   
        EntitiesBus.getInstance().publishMany([
            {
                type: `D ${this._schemaName}.${this._tableName}`,
                action: 'D',
                schema_name: this._schemaName,
                table_name: this._tableName,
                object_id: id,
                payload: {},
            },
        ]);
        if (this._rtSync) {
            RtService.publishDsMessage(this._schemaName, 'DELETE_' + this._tableName.toUpperCase(), { id }); //                       
        }
    }
    _onRtMessage = (messageType, payload) => {
        //                                                          
        const tableName = this._repo.getTableName().toUpperCase();
        if (messageType === 'CREATE_' + tableName)
            this._onRtMessageCreate([payload]);
        else if (messageType === 'CREATE_' + tableName + 'S')
            this._onRtMessageCreate(payload);
        else if (messageType === 'ADD_' + tableName)
            this._onRtMessageCreate([payload]);
        else if (messageType === 'ADD_' + tableName + 'S')
            this._onRtMessageCreate(payload);
        else if (messageType === 'UPDATE_' + tableName)
            this._onRtMessageUpdate([payload]);
        else if (messageType === 'UPDATE_' + tableName + 'S')
            this._onRtMessageUpdate(payload);
        else if (messageType === 'DELETE_' + tableName)
            this._onRtMessageDelete([payload]);
        else if (messageType === 'DELETE_' + tableName + 'S')
            this._onRtMessageDelete(payload);
        else if (messageType === 'REMOVE_' + tableName)
            this._onRtMessageDelete([payload]);
        else if (messageType === 'REMOVE_' + tableName + 'S')
            this._onRtMessageDelete(payload);
    };
    _onRtMessageCreate(es) {
        es.forEach(e => this._updateInternalOneEntity(e)); //                                  
    }
    _onRtMessageUpdate(es) {
        es.forEach(e => this._updateInternalOneEntity(e)); //                                  
    }
    _onRtMessageDelete(es) {
        es.forEach(e => this._deleteInternalOneEntity(e.id)); //                                  
    }
    _updateInternalOneEntity(e) {
        const filters = this._repo.getFilters();
        if (!checkEntityOnFilters(e, filters))
            return;
        const entities = updateOneEntity(this._model, e, this._repo.getOrderBy());
        this._setModel(makeModel(this._model.error, this._model.loading, this._tableName, entities));
    }
    updateInternalManyEntities(es, toDelete) {
        const orderBy = this._repo.getOrderBy(), filters = this._repo.getFilters();
        let entities = this._model;
        es.forEach(e => {
            if (!checkEntityOnFilters(e, filters))
                return;
            entities = updateOneEntity(entities, e, orderBy); //                                                
        });
        if (Array.isArray(toDelete)) {
            toDelete.forEach(idToDelete => {
                const idx = entities.findIndex(entity => String(entity.id) === String(idToDelete));
                if (idx !== -1) {
                    if (entities === this._model)
                        entities = entities.slice(0); //                               
                    entities.splice(idx, 1);
                }
            });
        }
        this._setModel(makeModel(this._model.error, this._model.loading, this._tableName, entities));
    }
    _deleteInternalOneEntity(id) {
        const idx = this._model.findIndex(entity => String(entity.id) === String(id));
        if (idx === -1)
            return;
        const entities = this._model.slice(0);
        entities.splice(idx, 1);
        this._setModel(makeModel(this._model.error, this._model.loading, this._tableName, entities));
    }
    async _reloadEntityWithId(id) {
        const e = await this._repo.getById(id);
        this._updateInternalOneEntity(e);
        return e;
    }
}
__decorate([
    memLock
], BaseEntitiesService.prototype, "_init", null);
__decorate([
    memLock
], BaseEntitiesService.prototype, "_create", null);
__decorate([
    memLock
], BaseEntitiesService.prototype, "_updateOne", null);
__decorate([
    memLock
], BaseEntitiesService.prototype, "_updateMany", null);
__decorate([
    memLock
], BaseEntitiesService.prototype, "_createMany", null);
__decorate([
    memLock
], BaseEntitiesService.prototype, "_remove", null);
__decorate([
    memLock
], BaseEntitiesService.prototype, "_reloadEntityWithId", null);
